module.exports = __webpack_public_path__ + "static/media/41.9698c2ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/41.jpg
// module id = 410
// module chunks = 0